import { editor, site } from '@ce/sen-n-components';
if (site === null || site === void 0 ? void 0 : site.components) {
    Object.entries(site.components).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        window[key] = value;
    });
}
if (editor === null || editor === void 0 ? void 0 : editor.react) {
    Object.entries(editor.react).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        window[key] = value;
    });
}
